import SplitText from './lib/SplitText'
import UI from './utils/UI'
import { TimelineLite } from 'gsap'
import { clamp, random } from './utils/math'
import { mq } from './config'
import bus from './bus'

UI({
  component: '.js-title'
}, ({ component }) => {
  bus.on('fonts-loaded', _ => {
    const tl = new TimelineLite({ paused: true, onComplete: _ => bus.emit('title-ready') })
    const splitted = new SplitText(component, { type: 'chars, words, lines', wordsClass: 'Title-word', charsClass: 'Title-char' })
    const scaleFactor = mq.md.matches ? 4 : mq.sm.matches ? 2 : 1
    fitWords(splitted.words, component.clientWidth)
    bus.on('window-resize', _ => fitWords(splitted.words, component.clientWidth))

    tl.set(component, { opacity: 1 })
    splitted.chars.forEach(char => {
      const y = random(-scaleFactor, scaleFactor)
      tl.fromTo(char, 0.045, { opacity: 0, y: 10 }, { opacity: 1, y }, '-=0.025')
    })

    const animateOn = component.dataset.animateOn
    if (animateOn) {
      bus.on(animateOn, _ => tl.paused(false))
    } else {
      tl.paused(false)
    }
  })

  function fitWords (words, maxWidth) {
    words.forEach(word => {
      word.style.removeProperty('font-size')
      fitWord(word, maxWidth)
    })
  }

  function fitWord(word, maxWidth) {
    const currentFontSize = parseInt(window.getComputedStyle(word, null).getPropertyValue('font-size'), 10)
    const min = 16
    const max = 82

    if (word.clientWidth > maxWidth && currentFontSize > min) {
      word.style.fontSize = clamp((currentFontSize - 6), min, max) + 'px'
      fitWord(word, maxWidth)
    }
  }
})
